import { render, staticRenderFns } from "./Sdt.vue?vue&type=template&id=629c7b08&scoped=true&"
import script from "./Sdt.vue?vue&type=script&lang=js&"
export * from "./Sdt.vue?vue&type=script&lang=js&"
import style0 from "./Sdt.vue?vue&type=style&index=0&id=629c7b08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629c7b08",
  null
  
)

export default component.exports